import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const OnDemand = () => {

    const FrontEnddevelopers = [
        {
            name: 'Aravind',
            image: '/assets/images/hire-1.png',
            devRole: 'Front End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Dinesh Kumar',
            image: '/assets/images/hire-2.png',
            devRole: 'Front End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Raja Laxman',
            image: '/assets/images/hire-3.png',
            devRole: 'Front End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Mani',
            image: '/assets/images/hire-1.png',
            devRole: 'Front End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Ram Charan',
            image: '/assets/images/hire-2.png',
            devRole: 'Front End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Joe Ben',
            image: '/assets/images/hire-3.png',
            devRole: 'Front End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
    ]

    const BackEnddevelopers = [
        {
            name: 'Joe Ben',
            image: '/assets/images/hire-1.png',
            devRole: 'Back End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Dinesh Kumar',
            image: '/assets/images/hire-2.png',
            devRole: 'Back End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Raja Laxman',
            image: '/assets/images/hire-3.png',
            devRole: 'Back End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Joe Ben',
            image: '/assets/images/hire-1.png',
            devRole: 'Back End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Dinesh Kumar',
            image: '/assets/images/hire-2.png',
            devRole: 'Back End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Raja Laxman',
            image: '/assets/images/hire-3.png',
            devRole: 'Back End Developer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        }
    ]

    const UIDesigner = [
        {
            name: 'Dinesh Kumar',
            image: '/assets/images/hire-1.png',
            devRole: 'UI/UX Designer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Raja Laxman',
            image: '/assets/images/hire-2.png',
            devRole: 'UI/UX Designer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
        {
            name: 'Dennis Rajan',
            image: '/assets/images/hire-3.png',
            devRole: 'UI/UX Designer',
            devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
            hireBtn: 'Hire Now',
            path: '/contact'
        },
    ]

  return (
    <>
    
        {/* On Demand Developers Banner */}
        <section className='about-page'>
            <div className='on-demand-bg'>
                <div className='c-detail-shap-1 con-shap-c'>
                    <img src="../assets/images/whi-5.svg" alt="" />
                </div>
                <div className='about-shap-3'>
                    <img src="../assets/images/about-shap-1.png" alt="" />
                </div>
                <div className='about-shap-4'>
                    <img src="../assets/images/about-shap-2.png" alt="" />
                </div>
                <div className='about-shap-5 con-shap-c'>
                    <img src="../assets/images/about-shap-3.svg" alt="" />
                </div>
                <div className='on-shap'>
                    <img src="../assets/images/whi-3.svg" alt="" />
                </div>
                <div className='on-san'>
                    <img src="../assets/images/on-san.svg" alt="" />
                </div>

                <Container>
                    <Row className='align-items-center'>
                        <div className='col-lg-5 d-lg-block d-none' data-aos="fade-right" data-aos-duration="2000">
                            <div className='position-relative'>
                                <div className='career-img text-center'>
                                    <img src="../assets/images/on-demand-img.png" alt="" />
                                </div>
                                <div className='on-demand-shap-7'>
                                    <img src="../assets/images/on-demand-shap-7.svg" alt="" />
                                </div>
                                <div className='on-demand-shap-1'>
                                    <img src="../assets/images/on-demand-shap-1.svg" alt="" />
                                </div>
                                <div className='on-demand-shap-2'>
                                    <img src="../assets/images/on-demand-shap-2.svg" alt="" />
                                </div>
                                <div className='on-demand-shap-3'>
                                    <img src="../assets/images/on-demand-shap-3.svg" alt="" />
                                </div>
                                <div className='on-demand-shap-4'>
                                    <img src="../assets/images/on-demand-shap-4.svg" alt="" />
                                </div>
                                <div className='on-demand-shap-5'>
                                    <img src="../assets/images/on-demand-shap-5.svg" alt="" />
                                </div>
                                <div className='on-demand-shap-6'>
                                    <img src="../assets/images/on-demand-shap-6.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='pb-lg-5 col-xl-6 col-lg-5 p-r-l' data-aos="fade-left" data-aos-duration="2000">
                            <div className='tech-content'>
                                <h2>On Demand Developers</h2>
                                <p>Access top-tier development talent exactly when you need it. Our on-demand developers integrate seamlessly with your team, accelerating projects with expertise in web, mobile, and custom software. Whether short-term or long-term, scale your development efforts efficiently—without the overhead of full-time hiring. </p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>

        {/* Front End Developer Section */}
        <section className='frontend-developer-section'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>Front End Developers</h5>
                    <h4>Lorem ipsum dolor sit amet, consetetur sadipscing</h4>
                </div>

                <Row>
                    {
                        FrontEnddevelopers.map((FrontEnd,index)=>(
                            <div key={index} className='col-lg-4 col-sm-6 developer-margin'>
                                <Link to={FrontEnd.path}>
                                    <div className="developer-card">
                                        <div className='developer-flex' data-aos="fade-up" data-aos-duration="2000">
                                            <div className='role-icon'>
                                                <img src={FrontEnd.image} alt="" />
                                            </div>
                                            <div className='developer-details'>
                                                <h4>{FrontEnd.name}</h4>
                                                <h6>{FrontEnd.devRole}</h6>
                                            </div>
                                        </div>
                                        <div className='dev-description' data-aos="fade-up" data-aos-duration="2500">
                                            <p>{FrontEnd.devDescription}</p>
                                        </div>
                                        <div className='dev-btn'>
                                            <button>{FrontEnd.hireBtn}</button>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))
                    }
                </Row>
            </Container>
        </section>

        {/* Back End Developers Section */}
        <section className='backend-developer-section'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>Back End Developers</h5>
                    <h4>Lorem ipsum dolor sit amet, consetetur sadipscing</h4>
                </div>

                <Row>
                    {
                        BackEnddevelopers.map((BackEnd,index)=>(
                            <div key={index} className='col-lg-4 col-sm-6 developer-margin'>
                                <Link to={BackEnd.path}>
                                    <div className="developer-card">
                                        <div className='developer-flex' data-aos="fade-up" data-aos-duration="2000">
                                            <div className='role-icon'>
                                                <img src={BackEnd.image} alt="" />
                                            </div>
                                            <div className='developer-details'>
                                                <h4>{BackEnd.name}</h4>
                                                <h6>{BackEnd.devRole}</h6>
                                            </div>
                                        </div>
                                        <div className='dev-description' data-aos="fade-up" data-aos-duration="2500">
                                            <p>{BackEnd.devDescription}</p>
                                        </div>
                                        <div className='dev-btn'>
                                            <button>{BackEnd.hireBtn}</button>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))
                    }
                </Row>
            </Container>
        </section>

        {/* UI/UX Designer Section */}
        <section className='ui-designer-section'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>UI/UX Designer</h5>
                    <h4>Lorem ipsum dolor sit amet, consetetur sadipscing</h4>
                </div>

                <Row>
                    {
                        UIDesigner.map((UIdesi,index)=>(
                            <div key={index} className='col-lg-4 col-sm-6 developer-margin'>
                                <Link to={UIdesi.path}>
                                    <div className="developer-card">
                                        <div className='developer-flex' data-aos="fade-up" data-aos-duration="2000">
                                            <div className='role-icon'>
                                                <img src={UIdesi.image} alt="" />
                                            </div>
                                            <div className='developer-details'>
                                                <h4>{UIdesi.name}</h4>
                                                <h6>{UIdesi.devRole}</h6>
                                            </div>
                                        </div>
                                        <div className='dev-description' data-aos="fade-up" data-aos-duration="2500">
                                            <p>{UIdesi.devDescription}</p>
                                        </div>
                                        <div className='dev-btn'>
                                            <button>{UIdesi.hireBtn}</button>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))
                    }
                </Row>
            </Container>
        </section>
    
    </>
  )
}
